module.exports = __webpack_public_path__ + "img/contentsShareIcon.80ede11d.svg";